import React, { Component } from 'react';
import $ from "jquery";
import ItemsCreateModal from './ItemsCreateModal';
import PdfViewer from './PdfViewer';
import Select from 'react-select';
import { decodeText } from '../libs/utils/Const';

class ReportKardexModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportKardexModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    ChangeWhsCode = event => {
        const { ListWhsCodes, ChangeWhsCode } = this.props
        let whsCode = null
        if (event && event.value !== undefined) {
            whsCode = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            whsCode = event.nativeEvent.target.value;
        }
        else {
            whsCode = '';
        }
        const findWhs = ListWhsCodes.find(whs => whs.WhsCode == whsCode)

        let whs = {
            nativeEvent: {
                target: {
                    value: `${whsCode}|${findWhs?.WhsName}`
                }
            }
        }

        ChangeWhsCode(whs)
    };

    render() {
        const {
            ReportsModel,
            ListWhsCodes,
            ChangeWhsCode,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ChangeItemCode,
            OpenItems,
            items,
            pageTotal,
            ClenDataItems,
            SelectItems,
            RefreshItems,
            GenerateReportKardex,
            ShowPDFViewerModal,
            ListReports,
            ShowPDFViewer,
            MailTools,
            printhide,
            ShowFormatToPrint
        } = this.props;
        const whsOptions = ListWhsCodes ? ListWhsCodes.map(whs => ({
            value: whs.WhsCode,
            label: `${whs.WhsCode} - ${decodeText(whs.WhsName)}`
        })) : [];
        const whsSelected = String(ReportsModel?.WhsCode ?? '').split('|')
        return (
            <div className="modal fade" id="reportKardexModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportKardexModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Kardex</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">

                                <div className='row'>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Almacen:</strong></span>
                                            </div>
                                            <Select
                                                options={whsOptions}
                                                value={whsOptions.find(opt => opt.value === whsSelected?.[0] ?? '') || null}
                                                onChange={(e) => this.ChangeWhsCode(e)}
                                                placeholder="Escribe para buscar almacen"
                                                isSearchable={true}
                                                isClearable={true}
                                                menuPortalTarget={document.body}
                                                noOptionsMessage={() => 'No se encontraron coincidencias'}
                                                styles={{
                                                    container: (base) => ({ ...base, flex: 1 }),
                                                    control: (base) => ({ ...base, height: 40, minHeight: 40, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                                                    singleValue: (base) => ({ ...base, color: "#000" })
                                                }}
                                            />
                                            {/* <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.WhsCode}
                                                onChange={event => ChangeWhsCode(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!ListWhsCodes && ListWhsCodes.map(list => {
                                                    return (
                                                        <option value={list.WhsCode + '|' + list.WhsName}>{`${list.WhsName}`}</option>
                                                    )
                                                })}
                                            </select> */}
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Artículo: </strong></span>
                                            </div>
                                            <input
                                                type="text" className="form-control"
                                                value={ReportsModel.ItemCode}
                                                onChange={(event) => ChangeItemCode(event)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        OpenItems();
                                                    }
                                                }}
                                            />
                                            <button type="button"
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    paddingTop: 2,
                                                    paddingBottom: 2,
                                                }}
                                                className="input-group-text"
                                                onClick={OpenItems}
                                            >
                                                <i className="fa fa-list" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Descripción: </strong></span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled
                                                value={ReportsModel.ItemName}
                                            />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReportKardex()}>Generar</button>
                        </div>
                    </div>
                </div>
                <ItemsCreateModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={ReportsModel}
                    mainView={'transfersRequest'}
                    selectItems={SelectItems}
                    cleanData={ClenDataItems}
                    refreshItems={RefreshItems}
                    DisabledItems={true}
                />
                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        ActualDate={ActualDate}
                        TypeDoc={'ReportKardex'}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={'SalesTools.EditableDocModel'}
                        RefreshDocModel={'SalesTools.RefreshDocModel'}
                        SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                        UploadDoc={'SalesTools.UploadInvoice'}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={'user'}
                        Counter={true}
                        ReportsModel={ReportsModel}
                        MailTools={MailTools}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }
            </div>
        );
    }
}

export default ReportKardexModal;